/// <reference types="./ContentTypeUtils.d.ts" />
import { FieldType, } from '../schema/SchemaSpecification.js';
import { RichTextNodeType, } from '../Types.js';
/** Check if `value` with `fieldSpec` is a single boolean field */
export function isBooleanSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Boolean && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list boolean field */
export function isBooleanListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Boolean && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single boolean field or an item in a list field */
export function isBooleanItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Boolean;
}
/** Check if `value` with `fieldSpec` is a single Component field */
export function isComponentSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Component && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list Component field */
export function isComponentListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Component && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single Component field or an item in a list field */
export function isComponentItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Component;
}
/** Check if `value` with `fieldSpec` is a single Reference field */
export function isReferenceSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Reference && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list Reference field */
export function isReferenceListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Reference && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single Reference field or an item in a list field */
export function isReferenceItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Reference;
}
/** Check if `value` with `fieldSpec` is a single Location field */
export function isLocationSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Location && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list Location field */
export function isLocationListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Location && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single Location field or an item in a list field */
export function isLocationItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Location;
}
/** Check if `value` with `fieldSpec` is a single number field */
export function isNumberSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Number && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list number field */
export function isNumberListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Number && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single number field or an item in a list field */
export function isNumberItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.Number;
}
/** Check if `value` with `fieldSpec` is a single String field */
export function isStringSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.String && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list String field */
export function isStringListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.String && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single String field or an item in a list field */
export function isStringItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.String;
}
/** Check if `value` with `fieldSpec` is a single RichText field */
export function isRichTextSingleField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.RichText && !fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is a list RichText field */
export function isRichTextListField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.RichText && fieldSpec.list;
}
/** Check if `value` with `fieldSpec` is either a single RichText field or an item in a list field */
export function isRichTextItemField(fieldSpec, _value) {
    return fieldSpec.type === FieldType.RichText;
}
export function isRichTextTextNode(node) {
    return node.type === RichTextNodeType.text;
}
export function isRichTextLineBreakNode(node) {
    return node.type === RichTextNodeType.linebreak;
}
export function isRichTextTabNode(node) {
    return node.type === RichTextNodeType.tab;
}
export function isRichTextElementNode(node) {
    return 'children' in node;
}
export function isRichTextRootNode(node) {
    return node.type === RichTextNodeType.root;
}
export function isRichTextParagraphNode(node) {
    return node.type === RichTextNodeType.paragraph;
}
export function isRichTextComponentNode(node) {
    return node.type === RichTextNodeType.component;
}
export function isRichTextEntityNode(node) {
    return node.type === RichTextNodeType.entity;
}
export function isRichTextEntityLinkNode(node) {
    return node.type === RichTextNodeType.entityLink;
}
export function isRichTextCodeNode(node) {
    return node.type === RichTextNodeType.code;
}
export function isRichTextCodeHighlightNode(node) {
    return node.type === RichTextNodeType['code-highlight'];
}
export function isRichTextHeadingNode(node) {
    return node.type === RichTextNodeType.heading;
}
export function isRichTextLinkNode(node) {
    return node.type === RichTextNodeType.link;
}
export function isRichTextListNode(node) {
    return node.type === RichTextNodeType.list;
}
export function isRichTextListItemNode(node) {
    return node.type === RichTextNodeType.listitem;
}
//# sourceMappingURL=ContentTypeUtils.js.map